/**
 * External dependencies
 */
import { arrayMoveImmutable } from 'array-move';

import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

import {
	Button,
	ExternalLink
} from '@wordpress/components';

import { Fragment } from '@wordpress/element';

import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies
 */
import { SortableItem, SortableList } from './sortable.js';

const LayoutBuilder = ({
	attributes,
	setAttributes
}) => {
	const onSortEnd = ({ oldIndex, newIndex }) => {
		const template = arrayMoveImmutable( attributes.template, oldIndex, newIndex );
		setAttributes({ template });
	};
	return (
		<Fragment>
			<div
				className={ classnames(
					'th-sortable'
				) }
			>
				{/* <SortableItem
					attributes={ attributes }
					setAttributes={ setAttributes }
					template={ 'image' }
					disabled={ true }
				/> */}

				<SortableList
					attributes={ attributes }
					setAttributes={ setAttributes }
					onSortEnd={ onSortEnd }
					useDragHandle
					axis="y"
					lockAxis="y"
				/>
			</div>
		</Fragment>
	);
};

export default LayoutBuilder;
